import api from '@/services/base.service'

const methods = {
  getEstado(identificador) {
    return api.get(`/tareas/${identificador}/status`)
  },
  getStatusTareasByIdentificador(identificador) {
    return this.getEstado(identificador)
  }
}

export default methods
